import { importAll } from "./utils/importImages";

const clients = importAll(
  require.context("./images/logo/clients", false, /\.(png|jpe?g|svg)$/)
);

function Clients() {

    return (
    <div className="fourni-client-container">
      <h2 className="fourni-client-title">Nos Clients</h2>
      <div className="fourni-client-grid">
        {clients.map((f) => (
          <div key={f.name} className="fourni-client-card">
            <img src={f.logo} alt={f.name} className="fourni-client-logo" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Clients;